
/* injects from baggage-loader */
require('./style.scss');

import React, { useMemo } from "react";
import { t } from "../../../helpers/translator";
import Config from "../../../config/main";
import PropTypes from "prop-types";
import moment from "moment";

const DayFilter = ({ timeFilter, setTimeFilter }) => {
    const days = useMemo(() => Array.from({ length: Config.main.prematchDayFiltersCount }, (v, i) => i + 1), []);

    return <div className="day-contain-mini-t">
        <div className="day-filter-m">
            <ul className="hide-checked">
                <li onClick={setTimeFilter(0)}
                    className={timeFilter === 0 ? "active" : ''}>
                    <p>{Config.enableTodayButtonOnSport ? t("24h") : t("All")}</p>
                </li>
                {
                    Config.enableDayFormatInPrematchLeftMenu && window.location.pathname.includes('prematch') ? Config.main.prematchDayFilterValue.map(interval => {
                        return <li key={interval} onClick={setTimeFilter(interval)} className={timeFilter === interval ? "active" : ''}>
                            {interval === 999 ? <p>{t(`All`)}</p>
                                : <p>{interval === (-1)
                                    ? t("Today")
                                    : moment.unix((new Date(new Date()).getTime() + interval * 24 * 60 * 60 * 1000) / 1000).format("MMM DD")} {interval !== 'today' ? "" : t("Today's Bets")}</p>
                            }
                        </li>;
                    })
                        : <>
                            {
                                Config.main.prematchTimeFilterValues.map(interval => {
                                    return <li key={interval} onClick={setTimeFilter(interval)} className={timeFilter === interval ? "active" : ''}>
                                        <p>{interval !== 'today' ? interval : ''} {interval !== 'today' ? t("hrs") : t("Today's Bets")}</p>
                                    </li>;
                                })
                            }
                            {
                                days.map(day => {
                                    const dayFormatted = moment(new Date()).add("day", day).format('DD.MM.YY')
                                    const hours = (day * 24) + (24 - +moment(new Date()).hour())

                                    return (
                                        <li key={day} onClick={setTimeFilter(hours)} className={hours === timeFilter ? 'active' : ''}>
                                            <p>{dayFormatted}</p>
                                        </li>
                                    )
                                })
                            }
                        </>
                }
            </ul>
        </div>
    </div>;

}

DayFilter.propTypes = {
    setTimeFilter: PropTypes.func,
    timeFilter: PropTypes.number
};

export default DayFilter;